<template>
  <div id="views">
    <audio controls="controls" ref="audio" preload autoplay hidden>
      <source :src="srcmp3" type="audio/mpeg" />
    </audio>

    <!-- <router-link to="/view1"> -->
    <img src="http://bz.njrentong.com/标题区.png" class="topImage" />
    <!-- </router-link> -->
    <div class="topButton">
      <div class="topbtn1">
        <div class="topbtn2" @click="operate(2)">停止</div>
        <div class="topbtn2" @click="operate(1)">启动</div>
      </div>

      <div class="topbtn3">
        <div class="topbtn2" @click="operate(3)">暂停</div>
        <div class="topbtn2" @click="operate(4)">继续</div>
      </div>
      <div class="topbtn66">
        <img src="@/assets/f11.png" class="f11" @click="screenfull" />
      </div>
    </div>

    <div class="topContent">
      <div class="left3">
        <div class="left1bgn"></div>
        <div class="left1_icon1"></div>
        <div class="left1_icon2"></div>
        <div class="left1_txt">
          <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
          <div>巡场完成度</div>
        </div>
        <div class="topContent_txt">
          <div id="charts1" class="chartsv3"></div>
          <div class="topContent_txt1">
            <div class="topContent_txt2">
              <!-- 2021 年 07 月 22 日 -->
              {{ y1 }}
              <div>{{ y2 }}</div>
            </div>
            <div class="topContent_txt3">
              <div class="topContent_txt4">
                <div class="topContent_txt5"></div>
              </div>
              <div class="topContent_txt6">机器人当前状态</div>
              <div class="topContent_txt7">{{ robotState }}</div>
            </div>

            <div class="topContent_txt8">
              <div class="topContent_txt4">
                <div class="topContent_txt5"></div>
              </div>
              <div class="topContent_txt6">当前速度</div>
              <div class="topContent_txt7" style="color: #fff">
                {{ robotSpeed }}m/s
              </div>
            </div>

            <div class="topContent_txt8">
              <div class="topContent_txt4">
                <div class="topContent_txt5"></div>
              </div>
              <div class="topContent_txt6">当前运行模式</div>
              <div class="topContent_txt7" style="color: #fff">
                {{ robotMode }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="left2">
        <div class="left1bgn"></div>
        <div class="left1_icon1"></div>
        <div class="left1_icon2"></div>
        <div class="left1_txt">
          <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
          <div>任务列表</div>
        </div>
        <div class="left2Content" v-cloak>
          <!-- <img src="http://bz.njrentong.com/robot.gif" class="robot" v-cloak /> -->
          <el-image src="http://bz.njrentong.com/robot.gif" class="robot">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <dv-scroll-board :config="config" class="left2center_col3table" />
        </div>
      </div>

      <div class="left1">
        <div class="left1bgn"></div>
        <div class="left1_icon1"></div>
        <div class="left1_icon2"></div>
        <el-image class="topContentimg" :src="imgUrl"></el-image>
        <!-- <el-image
          class="topContentimg"
          src="http://bz.njrentong.com/map10.png"
        ></el-image> -->
        <!-- <canvas id="mycanvas" width="642" height="238.5" class="cans"></canvas>

        <canvas id="mycanvas1" width="642" height="238.5" class="cans"></canvas> -->
        <!-- <van-image class="topContentimg" src="./map/png" /> -->
        <!-- <div
          class="robotDot"
          :style="
            'left:' +
            getCurrentCoordinatesInfo.x +
            'px;' +
            ';' +
            'top:' +
            getCurrentCoordinatesInfo.y +
            'px;'
          "
        ></div> -->
      </div>
    </div>
    <div class="centerContent">
      <div class="centerlabel">
        <div class="centerContenttxt1">累计巡逻距离</div>
        <div class="centerContenttxt2">
          <animate-number
            from="0"
            :to="totalDistance"
            :key="totalDistance"
            duration="2000"
            easing="easeOutQuad"
          ></animate-number>
        </div>
        <div class="centerContenttxt3">千米</div>
      </div>
      <div class="centerlabel">
        <div class="centerContenttxt4">剩余电量</div>
        <div class="centerContenttxt5">
          <animate-number
            from="0"
            :to="batteryPercentage"
            :key="batteryPercentage"
            duration="2000"
            easing="easeOutQuad"
          ></animate-number
          >%
        </div>
      </div>

      <div class="centerlabel">
        <div class="centerContenttxt6">累计工作时间</div>
        <div class="centerContenttxt7">
          <div class="box-item">
            <li
              :class="{
                'number-item': !isNaN(item),
                'mark-item': isNaN(item),
              }"
              v-for="(item, index) in orderNum"
              :key="index"
            >
              <span v-if="!isNaN(item)">
                <i ref="numberItem">0123456789</i>
              </span>
              <span class="comma" v-else>{{ item }}</span>
            </li>
          </div>
        </div>
        <div class="centerContenttxt8">天</div>
        <div class="centerContenttxt9">
          <div class="box-item">
            <li
              :class="{
                'number-item': !isNaN(item),
                'mark-item': isNaN(item),
              }"
              v-for="(item, index) in orderNum1"
              :key="index"
            >
              <span v-if="!isNaN(item)">
                <i ref="numberItem1">0123456789</i>
              </span>
              <span class="comma" v-else>{{ item }}</span>
            </li>
          </div>
        </div>
        <div class="centerContenttxt8" style="margin-left: 2px">小时</div>
        <div class="centerContenttxt9">
          <div class="box-item">
            <li
              :class="{
                'number-item': !isNaN(item),
                'mark-item': isNaN(item),
              }"
              v-for="(item, index) in orderNum3"
              :key="index"
            >
              <span v-if="!isNaN(item)">
                <i ref="numberItem3">0123456789</i>
              </span>
              <span class="comma" v-else>{{ item }}</span>
            </li>
          </div>
        </div>
        <div class="centerContenttxt8">分</div>
        <div class="centerContenttxt9">
          <div class="box-item">
            <li
              :class="{
                'number-item': !isNaN(item),
                'mark-item': isNaN(item),
              }"
              v-for="(item, index) in orderNum4"
              :key="index"
            >
              <span v-if="!isNaN(item)">
                <i ref="numberItem4">0123456789</i>
              </span>
              <span class="comma" v-else>{{ item }}</span>
            </li>
          </div>
        </div>
        <div class="centerContenttxt8">秒</div>
      </div>
      <div class="centerlabel">
        <div class="centerContenttxt10">累计完成巡逻任务</div>
        <div class="centerContenttxt5">
          <!-- :key="batteryPercentage" -->

          <animate-number
            from="0"
            :to="taskNum"
            :key="taskNum"
            duration="1000"
            easing="easeOutQuad"
          ></animate-number>
        </div>
        <div class="centerContenttxt3">次</div>
      </div>
    </div>
    <div class="bottomContent">
      <div class="bottomContent1">
        <div class="left1bgn"></div>
        <div class="left1_icon1"></div>
        <div class="left1_icon2"></div>
        <div class="bottomContent1_txt">
          <!-- <el-image class="bottomContent1Img" :src="LastImg"></el-image> -->
          <el-image
            class="bottomContent1Img"
            :src="getRobotLastImgUrl"
          ></el-image>
          <!-- <div id="video5" class="bottomContent1Img"></div> -->

          <!-- <img class="bottomContent1Img" :src="LastImg" /> -->
          <!-- <div class="bottomContent1Img"> -->
          <!-- <div id="video-container" class="bottomContent1Img"></div> -->
          <!-- </div> -->

          <dv-scroll-board :config="config1" class="bottomContent1_txttable" />
        </div>
        <div class="bottomContent1_txt2">当日停车位状态统计</div>
        <div class="bottomContent1_txt3">
          <div id="charts2" class="charts1"></div>
          <div id="charts3" class="charts1"></div>
        </div>
      </div>
      <div class="bottomContent2">
        <div class="left1bgn"></div>
        <div class="left1_icon1"></div>
        <div class="left1_icon2"></div>
        <div class="bottomContent2txt">
          <animate-number
            from="0"
            :to="allTip"
            :key="allTip"
            duration="2000"
            easing="easeOutQuad"
          ></animate-number>
          <div class="bottomContent2txt1">个</div>
        </div>
        <div class="bottomContent2txt2">异常告警数</div>
        <div class="bottomContent2txt3">
          <div class="bottomContent2txt4">
            <img src="http://bz.njrentong.com/ok.png" class="ok" />
            <div class="bottomContent2txt5">
              <div class="bottomContent2txt6">已处理数</div>
              <div class="bottomContent2txt7">
                <animate-number
                  from="0"
                  :to="alreadySolve"
                  :key="alreadySolve"
                  duration="1000"
                  easing="easeOutQuad"
                ></animate-number>
                <div class="bottomContent2txt8">个</div>
              </div>
            </div>
          </div>
          <div class="bottomContent2txt4">
            <img src="http://bz.njrentong.com/weichuli.png" class="ok" />
            <div class="bottomContent2txt5">
              <div class="bottomContent2txt6">未处理数</div>
              <div class="bottomContent2txt7" style="color: #9601eb">
                <animate-number
                  from="0"
                  :to="noSolve"
                  :key="noSolve"
                  duration="1000"
                  easing="easeOutQuad"
                ></animate-number>
                <div class="bottomContent2txt8">个</div>
              </div>
            </div>
          </div>
        </div>
        <div id="charts4" class="charts4"></div>
      </div>
      <div class="bottomContent3">
        <div class="left1bgn"></div>
        <div class="left1_icon1"></div>
        <div class="left1_icon2"></div>
        <div class="bottomContent3Dia" v-if="showDia">
          <div class="bottomContent3Diatxt">
            告警信息
            <img
              src="http://bz.njrentong.com/guanbi.png"
              class="bottomContent3Diaimg"
              @click="showDia = false"
            />
          </div>
          <div class="bottomContent3Diatxt2">
            告警时间
            <div class="bottomContent3Diatxt3">
              {{
                alertTip[alertIndex].addTime == undefined
                  ? ""
                  : alertTip[alertIndex].addTime
              }}
            </div>
          </div>
          <div class="bottomContent3Diatxt4">
            告警设备
            <div class="bottomContent3Diatxt3">机器人</div>
          </div>
          <div class="bottomContent3Diatxt4">
            告警停车场
            <div class="bottomContent3Diatxt3">
              {{
                alertTip[alertIndex].parkName == undefined
                  ? ""
                  : alertTip[alertIndex].parkName
              }}
            </div>
          </div>
          <div class="bottomContent3Diatxt4">
            告警内容
            <div class="bottomContent3Diatxt3">
              {{
                (alertTip[alertIndex].parkSpotNo == undefined
                  ? ""
                  : alertTip[alertIndex].parkSpotNo) +
                "号" +
                (alertTip[alertIndex].dictionaryName == undefined
                  ? ""
                  : alertTip[alertIndex].dictionaryName)
              }}
            </div>
          </div>
        </div>

        <div class="left1_txt">
          <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
          <div>实时监控画面</div>
        </div>

        <div class="bottomContent3txt11" id="unview">
          <div id="video1" class="bottomContent3img1"></div>
          <div id="video2" class="bottomContent3img1"></div>
          <div id="video3" class="bottomContent3img1"></div>
          <div id="video4" class="bottomContent3img1"></div>
        </div>
        <div class="bottomContent3txt1" id="unview4">
          <video
            id="videoElement3"
            controls
            autoplay
            muted
            class="view4"
          ></video>
          <video
            id="videoElement4"
            controls
            autoplay
            muted
            class="view4"
          ></video>

          <video
            id="videoElement1"
            controls
            autoplay
            muted
            class="view4"
          ></video>
          <video
            id="videoElement2"
            controls
            autoplay
            muted
            class="view4"
          ></video>
        </div>
        <dv-scroll-board
          :config="config2"
          class="bottomContent3txt2tablev3"
          @click="openDia"
        />
        <!-- @click="openDia" -->
      </div>
    </div>
  </div>
</template>

<script>
import screenfull from "screenfull";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import "videojs-flash";
import sounds from "@/assets/alarm.mp3";
import flvjs from "flv.js";

var echarts1;
var echarts2;
var echarts3;
var echarts4;
var countInter = null;
var that;
var player = null;
var player2 = null;
var player3 = null;
var player4 = null;
var player5 = null;

var interval1;
var interval2;
var interval3;
var interval4;
var interval5;

import {
  Toast,
  Button,
  Image as VanImage,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Divider,
  Field,
  Overlay,
  DatetimePicker,
  Picker,
  Dialog,
  Cascader,
} from "vant";
import { get, post } from "@/util/axios";
import { List } from "echarts";
export default {
  flvPlayer: null,
  name: "view3",
  components: {
    Toast,
    videoPlayer,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Cascader.name]: Cascader,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
    [Field.name]: Field,
    [Button.name]: Button,
    [VanImage.name]: VanImage,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [Overlay.name]: Overlay,

    [RadioGroup.name]: RadioGroup,
  },
  data() {
    return {
      srcmp3: sounds,
      robotId: 10,
      imgUrl: "http://bz.njrentong.com/map10.png",
      canvas: null,
      context: null,
      taskNum: 0,
      canvas1: null,
      context1: null,
      getCurrentCoordinatesInfo: { x: 0, y: 15 },
      LastImg: "",
      totalDistance: 0,
      batteryPercentage: 0,
      robotState: "暂无",
      robotSpeed: "0.0",
      robotMode: "暂无",
      alreadySolve: 0,
      noSolve: 0,
      allTip: 0,
      y1: "",
      y2: "",
      showDia: false,
      orderNum: ["0", "0"],
      orderNum1: ["0", "0"],
      orderNum3: ["0", "0"],
      orderNum4: ["0", "0"],
      config: {
        header: ["序号", "任务名称", "任务时间", "任务状态"],
        data: [],
        align: ["center", "center", "center", "center"],
        columnWidth: [60, 100, 220, 100],
        headerBGC: "transparent",
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
      },
      config1: {
        header: ["车位号", "车牌号码", "停放状态"],
        data: [],
        rowNum: 4,
        align: ["center", "center", "center"],
        columnWidth: [120, 120, 120],
        headerBGC: "transparent",
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
      },
      alertTip: [],
      alertIndex: 0,
      config2: {
        header: ["序号", "告警内容", "告警时间", "状态"],
        data: [],
        align: ["center", "center", "center", "center"],
        columnWidth: [80, 340, 350, 150],
        rowNum: 2,
        headerBGC: "transparent",
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
      },
      getSpotStatusCountInfo: [],
      option1: {
        color: ["#00FFF6", "#1A4D93"],

        series: [
          {
            name: "物料仓",
            type: "pie",
            stillShowZeroSum: false,
            radius: ["80%", "100%"], //通过调整两个参数可以调整环形的大小
            center: ["50%", "50%"], // 默认全局居中
            data: [
              {
                name: "",
                value: 0,
                label: {
                  show: true, //单独显示该数据项
                  formatter: "{d}%",
                  textStyle: {
                    // fontWeight: 800,
                    color: "#ffffff",
                    fontSize: 40,
                  },
                },
              },

              {
                value: 100,
                label: {
                  emphasis: {
                    show: false,
                  },
                },
              },
            ],
            itemStyle: {
              normal: {},
            },
            label: {
              normal: {
                //默认不显示数据
                show: false,
                position: "center",
              },
            },
          },
        ],
      },
      option2: {
        backgroundColor: "transparent",
        color: [
          "#00FFF7",
          "#FFF716",
          "#9601EB",
          "#0FDB7B",
          "#1C2D7F",
          "#1C2D7F",
        ],
        series: [
          {
            name: "正常停放数",
            type: "pie",
            radius: "75%",
            center: ["45%", "50%"],
            label: {
              fontSize: 20,
              fontWeight: "lighter",
              width: 200,
            },
            data: [
              { value: 0, name: "正常停放数", percent: "25" },
              { value: 0, name: "无车停放数", percent: "25" },
              { value: 0, name: "未正确停放数", percent: "25" },
              { value: 0, name: "车位被占数", percent: "25" },
            ],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "outside",
                  color: "#90A9C8",
                  fontWeight: "lighter",

                  formatter: function (params) {
                    if (params.name !== "") {
                      return params.name + "\n{white|" + params.value + "}";
                    } else {
                      return "";
                    }
                  },
                  rich: {
                    white: {
                      color: "#93FFFF",
                      align: "center",
                      padding: [5, 0],
                      fontSize: 20,
                    },
                  },
                },
                labelLine: {
                  length: 5,
                  length2: 2,
                  show: false,
                  color: "#00ffff",
                },
              },
            },
            roseType: "radius",
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function (idx) {
              return Math.random() * 200;
            },
          },
        ],
      },
      option3: {
        backgroundColor: "transparent",
        grid: {
          top: "20%",
          left: "7%",
          right: "2%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {
          data: ["正常停放", "无车停放", "车位被占", "未正确停放"],
          textStyle: {
            color: "#FFFFFF",
            fontSize: 10,
          },
          itemWidth: 12, // 设置宽度
          itemHeight: 16, // 设置高度
          // itemGap: 33, // 设置间距
        },
        xAxis: [
          {
            data: [],
            axisLabel: {
              margin: 10,
              color: "#A1D5FF",
              textStyle: {
                fontSize: 12,
              },
              showMaxLabel: true,
              interval: 0,
              rotate: 30,
            },
            axisLine: {
              lineStyle: {
                color: "#102E74",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#90A9C8",
              textStyle: {
                fontSize: 12,
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#273780",
              },
            },
          },
        ],
        series: [
          {
            name: "正常停放",
            type: "bar",
            data: [0],
            barWidth: "12px",
            itemStyle: {
              normal: {
                color: "#00FFF7",
                barBorderRadius: [30, 30, 0, 0],
              },
            },
          },
          {
            name: "无车停放",
            type: "bar",
            data: [0],
            barWidth: "12px",
            itemStyle: {
              normal: {
                color: "#FFF716",
                barBorderRadius: [30, 30, 0, 0],
              },
            },
          },
          {
            name: "车位被占",
            type: "bar",
            data: [0],
            barWidth: "12px",
            itemStyle: {
              normal: {
                color: "#9602EB",
                barBorderRadius: [30, 30, 0, 0],
              },
            },
          },
          {
            name: "未正确停放",
            type: "bar",
            data: [0],
            barWidth: "12px",
            itemStyle: {
              normal: {
                color: "#0FDB7B",
                barBorderRadius: [30, 30, 0, 0],
              },
            },
          },
        ],
      },
      videoList: [],
      getRobotLastImgUrl: "",
      option4: {
        backgroundColor: "transparent",
        series: [
          {
            name: "",
            type: "pie",
            radius: ["60%", "80%"],
            hoverAnimation: false,
            color: ["#00FFF6", "#9601EB"],
            labelLine: {
              normal: {
                length: 10,
                length2: 25,
                lineStyle: {
                  color: "#fff",
                },
              },
            },
            data: [
              {
                value: 0,
                name: "",
                label: {
                  show: true, //单独显示该数据项
                  formatter: function (data) {
                    let b = data.percent.toFixed(0) + "%";
                    return b;
                  },
                  align: "center",
                  textStyle: {
                    // fontWeight: 800,
                    color: "#ffffff",
                    fontSize: 20,
                  },
                },
              },

              {
                value: 0,
                name: "",
                label: {
                  show: true, //单独显示该数据项
                  formatter: function (data) {
                    let b = data.percent.toFixed(0) + "%";
                    return b;
                  },
                  textStyle: {
                    // fontWeight: 800,
                    color: "#ffffff",
                    fontSize: 20,
                  },
                },
              },
            ],
          },
        ],
      },
      count: 0,
    };
  },
  mounted() {
    that = this;
    this.$refs.audio.pause(); //停止
    console.log(this.$route);
    if (this.$route.query.id) {
      this.robotId = this.$route.query.id;
    }
    console.log(that.robotId);
    // if (that.robotId != 4) {
    //   document.getElementById("unview").style.display = "block";
    //   document.getElementById("unview4").style.display = "none";
    // } else if (that.robotId == 4) {
    //   document.getElementById("unview").style.display = "none";
    //   document.getElementById("unview4").style.display = "block";
    // }
    document.getElementById("unview4").style.display = "none";
    if (this.$route.query.img) {
      this.imgUrl =
        "http://yypark.njrentong.com/back/files/lidarPic/" +
        this.$route.query.img;

      // this.imgUrl = "http://bz.njrentong.com/" + this.$route.query.img;
    }
    // this.canvas = document.getElementById("mycanvas");
    // this.context = this.canvas.getContext("2d");
    // this.canvas1 = document.getElementById("mycanvas1");
    // this.context1 = this.canvas1.getContext("2d");
    echarts1 = this.$echarts.init(document.getElementById("charts1"));
    echarts2 = this.$echarts.init(document.getElementById("charts2"));
    echarts3 = this.$echarts.init(document.getElementById("charts3"));
    echarts4 = this.$echarts.init(document.getElementById("charts4"));
    that.getRobotLastImg();
    // that.drawLine();
    // that.getlogin();
    that.getAllTime();
    // interval1 = setInterval(function () {
    //   that.getTime();
    //   that.getAllTime();
    // }, 1000);
    that.getleft1();
    that.getState();
    that.getSpeed();
    that.getMode();
    that.getRobotTasks();
    that.getBatteryPercentage();
    // that.getLastImg();
    that.getSpotState();
    that.getTotalDistance();
    that.getSpotStatusCount();
    that.getSpotStatusCountHistogramFour();
    that.getCurrentCoordinates();

    //图灵监控视屏播放
    that.playflv1();
    that.playflv2();
    that.playflv3();
    that.playflv4();
    // that.getVirtualWall();
    // that.getPatrolRouteCoordinates();
    that.getPlayUrl();
    that.getTasks();
    //、告警（10秒刷一次）
    that.getBizSpotRecordWarnByState();
    that.getRecordWarn();
    //巡场完成度（5秒刷一次） \五、任务列表
    // interval2 = setInterval(function () {
    //   that.getleft1();
    //   that.getState();
    //   that.getSpeed();
    //   that.getMode();

    //   that.getRobotTasks();
    //   that.getBatteryPercentage();
    //   // that.getLastImg();
    //   that.getTotalDistance();

    //   that.getCurrentCoordinates();
    //   that.getTasks();
    // }, 5000);

    // interval3 = setInterval(function () {
    //   that.getRecordWarn();

    //   // that.getVirtualWall();
    //   // that.getPatrolRouteCoordinates();
    //   that.getSpotState();
    //   that.getRobotLastImg();
    // }, 10000);

    // interval4 = setInterval(function () {
    //   // that.getPlayUrl();
    //   window.location.reload();
    // }, 1000 * 60 * 30);
    // setTimeout(() => {
    //   this.toOrderNum(54); // 这里输入数字即可调用
    //   this.toOrderNum2(12); // 这里输入数字即可调用
    //   this.toOrderNum3(9); // 这里输入数字即可调用
    //   this.toOrderNum4(4); // 这里输入数字即可调用
    // }, 500);
    // interval5 = setInterval(function () {
    //   that.getSpotStatusCount();
    //   that.getSpotStatusCountHistogramFour();
    //   that.getBizSpotRecordWarnByState();
    // }, 30000);
  },

  destroyed() {
    clearInterval(interval1);
    clearInterval(interval2);
    clearInterval(interval3);
    clearInterval(interval4);
    clearInterval(interval5);
    clearInterval(countInter);
    if (player != null) {
      player.stop();
      player2.stop();
      player3.stop();
      player4.stop();
      // player5.stop();
    }
  },
  methods: {
    playflv1() {
      if (flvjs.isSupported()) {
        var videoElement1 = document.getElementById("videoElement1");
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          isLive: true,
          hasAudio: false,
          url: "http://ztl.njrentong.com/rtp/F77A5D96.live.flv", // 自己的flv视频流
        });
        this.flvPlayer.attachMediaElement(videoElement1);
        this.flvPlayer.load();
        // this.flvPlayer.play();
      }
    },
    playflv2() {
      if (flvjs.isSupported()) {
        var videoElement2 = document.getElementById("videoElement2");
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          isLive: true,
          hasAudio: false,
          url: "http://ztl.njrentong.com/rtp/D66FE863.live.flv", // 自己的flv视频流
        });
        this.flvPlayer.attachMediaElement(videoElement2);
        this.flvPlayer.load();
        this.flvPlayer.play();
      }
    },
    playflv3() {
      if (flvjs.isSupported()) {
        var videoElement3 = document.getElementById("videoElement3");
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          isLive: true,
          hasAudio: false,
          url: "http://ztl.njrentong.com/rtp/A55E4C2E.live.flv", // 自己的flv视频流
        });
        this.flvPlayer.attachMediaElement(videoElement3);
        this.flvPlayer.load();
      }
    },
    playflv4() {
      if (flvjs.isSupported()) {
        var videoElement4 = document.getElementById("videoElement4");
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          isLive: true,
          hasAudio: false,
          url: "http://ztl.njrentong.com/rtp/6FEE1897.live.flv", // 自己的flv视频流
        });
        this.flvPlayer.attachMediaElement(videoElement4);
        this.flvPlayer.load();
        this.flvPlayer.play();
      }
    },
    getlogin() {
      var testurl = window.location.href;
      var testurl2 = testurl.lastIndexOf("?");
      var testurl3 = testurl.substring(testurl.lastIndexOf("?"));
      // alert(testurl3);

      const gogo = window.sessionStorage.getItem("login");
      console.log(gogo);

      if (gogo != 996) {
        window.sessionStorage.setItem("view", testurl3);
        window.location.href = "login";
        return;
      }
    },

    getRobotLastImg() {
      post("/back/robot/getRobotLastImg", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          that.getRobotLastImgUrl = res.data;
        } else {
        }
      });
    },
    handleVideo(index, play) {
      post("/back/robot/getPlayUrl", { robotId: that.robotId }).then((res) => {
        if (res.state) {
          if (res.data.length == 0) {
            return;
          }
          play = new EZUIKit.EZUIKitPlayer({
            id: "video" + (index + 1), // 视频容器ID
            accessToken:
              index == 5
                ? res.data[0].data.accessToken
                : res.data[index].data.accessToken,
            url:
              index == 5
                ? "ezopen://open.ys7.com/248974558/1.hd.live"
                : res.data[index].data.url,
            audio: 0,
            handleError: function (e) {
              that.handleVideo(index);
            },
          });
          play.play();
        }
      });
    },
    getPlayUrl() {
      post("/back/robot/getPlayUrl", { robotId: that.robotId }).then((res) => {
        if (res.state) {
          if (res.data == null) {
            that.$message({
              showClose: true,
              message: "设备离线",
              type: "error",
            });
            return;
          }

          if (res.data.length == 0) {
            return;
          }
          that.videoList = res.data;
          if (player != null) {
            player.stop().then(() => {
              player.play(res.data[0].data.url);
            });
            player2.stop().then(() => {
              player2.play(res.data[1].data.url);
            });
            player3.stop().then(() => {
              player3.play(res.data[2].data.url);
            });
            player4.stop().then(() => {
              player4.play(res.data[3].data.url);
            });
            // player5.stop().then(() => {
            //   player5.play("ezopen://open.ys7.com/248974558/1.live");
            // });
            return;
          }
          player = new EZUIKit.EZUIKitPlayer({
            id: "video1", // 视频容器ID
            accessToken: res.data[0].data.accessToken,
            url: res.data[0].data.url,
            audio: 0,
            handleError: function (e) {
              player.stop().then(() => {
                player.play(that.videoList[0].data.url);
              });
            },
          });
          player.play();
          player2 = new EZUIKit.EZUIKitPlayer({
            id: "video2", // 视频容器ID
            accessToken: res.data[1].data.accessToken,
            url: res.data[1].data.url,
            audio: 0,
            handleError: function (e) {
              player2.stop().then(() => {
                player2.play(that.videoList[1].data.url);
              });
            },
          });
          player2.play();
          player3 = new EZUIKit.EZUIKitPlayer({
            id: "video3", // 视频容器ID
            accessToken: res.data[2].data.accessToken,
            url: res.data[2].data.url,
            audio: 0,
            handleError: function (e) {
              player3.play(that.videoList[2].data.url);
            },
          });
          player3.play();
          player4 = new EZUIKit.EZUIKitPlayer({
            id: "video4", // 视频容器ID
            accessToken: res.data[3].data.accessToken,
            url: res.data[3].data.url,
            audio: 0,
            handleError: function (e) {
              player4.play(that.videoList[3].data.url);
            },
          });
          player4.play();

          // player5 = new EZUIKit.EZUIKitPlayer({
          //   id: "video5", // 视频容器ID
          //   accessToken: res.data[3].data.accessToken,
          //   url: "ezopen://open.ys7.com/248974558/1.live",
          //   audio: 0,
          //   handleError: function (e) {
          //     player5.play("ezopen://open.ys7.com/248974558/1.live");
          //   },
          // });
          // player5.play();
        } else {
          loading.close();
        }
      });
    },
    screenfull() {
      screenfull.toggle();
    },
    //任务完成数

    getTasks() {
      // that.taskNum = 0;
      post("/back/robot/getAllEndTasks", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          that.taskNum = res.data;
        } else {
          loading.close();
          // this.$message({
          //   showClose: true,
          //   message: res.message,
          //   type: "error",
          // });
        }
      });
    },
    timesFun(timesData) {
      //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
      var dateBegin = new Date(timesData.replace(/-/g, "/")); //将-转化为/，使用new Date
      var dateEnd = new Date(); //获取当前时间
      var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      var timesString = "";

      return {
        dayDiff,
        hours,
        minutes,
        seconds,
      };
    },
    getLastImg() {
      post("/back/robot/getLastImg", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.data == null || res.data === "") {
          return;
        }
        this.LastImg = "data:image/jpg;base64," + res.data[0].img;
        // let list = [];
        // let list1 = res.data;
        // let a = [];
        // list1.forEach((item, index) => {
        //   a.push(item.spotId);
        //   a.push(item.licensePlate);
        //   a.push(item.dictionaryName);
        //   list.push(a);

        //   a = [];
        // });
        // let da = JSON.parse(JSON.stringify(this.config1));

        // da.data = list;
        // this.config1 = da;
      });
    },
    getSpotState() {
      post("/back/robot/getSpotState", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.data == null || res.data === "") {
          return;
        }
        let list = [];
        let list1 = res.data;
        let a = [];
        list1.forEach((item, index) => {
          if (item.parkSpotNo) {
            a.push(item.parkSpotNo);
          } else {
            a.push("");
          }
          a.push(item.licensePlate);
          a.push(item.dictionaryName);
          list.push(a);

          a = [];
        });
        let da = JSON.parse(JSON.stringify(this.config1));

        da.data = list;
        this.config1 = da;
      });
    },
    //四个按钮操作
    operate(state) {
      const loading = this.$loading({
        lock: true,
        text: "操作中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      get("/back/robot/operationRobot", {
        robotId: that.robotId,
        type: state,
      })
        .then((res) => {
          if (res.state) {
            setTimeout(() => {
              loading.close();
              this.$message({
                showClose: true,
                message: res.message,
                type: "success",
              });
            }, 1000);
          } else {
            loading.close();
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          loading.close();
        });
    },
    getAllTime() {
      post("/back/robot/getAllTime", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          let time = this.timesFun(res.data);
          this.toOrderNum(time.dayDiff); // 这里输入数字即可调用
          this.toOrderNum2(time.hours); // 这里输入数字即可调用
          this.toOrderNum3(time.minutes); // 这里输入数字即可调用
          this.toOrderNum4(time.seconds); // 这里输入数字即可调用
        }
      });
    },
    //累计巡逻距离

    getTotalDistance() {
      // this.totalDistance = 0;
      post("/back/robot/getTotalDistance", {
        robotId: that.robotId,
      }).then((res) => {
        this.totalDistance = res.data;
      });
    },
    getCurrentCoordinates() {
      post("/back/robot/getCurrentCoordinates", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          if (res.data == null) {
            return;
          }
          this.getCurrentCoordinatesInfo = res.data;
        }
      });
    },
    //虚拟墙坐标

    getVirtualWall() {
      post("/back/robot/getVirtualWall", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          if (res.data == null) {
            return;
          }
          this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

          let a = res.data.sysVirtualWalls;
          a.forEach((item, index) => {
            that.draw(item.x1, item.y1, item.x2, item.y2, "red");
          });
        }
      });
    },
    //巡场路线数据

    getPatrolRouteCoordinates() {
      post("/back/robot/getPatrolRouteCoordinates", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          if (res.data == null) {
            return;
          }
          //清空画布
          this.context1.clearRect(
            0,
            0,
            this.canvas1.width,
            this.canvas1.height
          );
          let a = res.data.sysRouteCoordinatess;
          a.forEach((item, index) => {
            that.draw1(item.startx, item.starty, item.endx, item.endy, "green");
          });
        }
      });
    },
    draw(x1, y1, x2, y2, color) {
      this.context.moveTo(x1, y1);
      this.context.lineTo(x2, y2);
      this.context.strokeStyle = color;
      this.context.lineWidth = 2;
      this.context.stroke();
    },
    draw1(x1, y1, x2, y2, color) {
      this.context1.moveTo(x1, y1);
      this.context1.lineTo(x2, y2);
      this.context1.strokeStyle = color;
      this.context1.lineWidth = 2;
      this.context1.stroke();
    },
    //获取机器人当前电量的接口

    getBatteryPercentage() {
      // this.batteryPercentage = 0;
      post("/back/robot/getBatteryPercentage", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.data == null) {
          return;
        }
        this.batteryPercentage = res.data;
      });
    },
    //巡查完成度
    getleft1() {
      // echarts1.clear();
      // this.option1.series[0].data[0].value = 0;
      // this.option1.series[0].data[1].value = this.Subtr(100, 0);
      // echarts1.setOption(this.option1);
      get("/back/robot/getPercentage", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.message == null) {
          return;
        }
        let num = res.message.substr(0, res.message.indexOf("%"));
        // if (num == this.option1.series[0].data[0].value) {
        //   return;
        // }
        this.option1.series[0].data[0].value = num;
        this.option1.series[0].data[1].value = this.Subtr(100, num);
        // echarts1.clear();
        echarts1.setOption(this.option1);
      });
    },
    //机器人当前状态
    getState() {
      get("/back/robot/getState", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.message == null) {
          return;
        }
        this.robotState = res.message;
      });
    },
    //查询当日停车位状态统计（饼图）

    getSpotStatusCount() {
      // echarts2.clear();

      // echarts2.setOption(this.option2);

      get("/back/robot/getSpotStatusCount", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          if (res.data == null) {
            return;
          }
          let dd = [
            {
              value: res.data[0].num,
              name: "正常停放数",
              percent: res.data[0].percent,
            },
            {
              value: res.data[1].num,
              name: "车辆乱停车位",
              percent: res.data[1].percent,
            },
            {
              value: res.data[2].num,
              name: "未正确停放",
              percent: res.data[2].percent,
            },

            {
              value: res.data[3].num,
              name: "无车停放",
              percent: res.data[3].percent,
            },
          ];
          this.option2.series[0].data = dd;

          echarts2.setOption(this.option2);

          this.getSpotStatusCountInfo = res.data;
        }
      });
    },
    //查询前四日停车位状态统计（柱状图）

    getSpotStatusCountHistogramFour() {
      // echarts3.clear();

      echarts3.setOption(this.option3);
      post("/back/robot/getSpotStatusCountHistogramFour", {
        robotId: that.robotId,
      }).then((res) => {
        if (res.state) {
          if (res.data == null) {
            return;
          }
          let dd = res.data;
          let dateList = [];
          let typeList = ["正常停放", "车辆乱停车位", "未正确停放", "无车停放"];
          let d1 = [];
          let d2 = [];
          let d3 = [];
          let d4 = [];
          dd.forEach((item, index) => {
            dateList.push(item.dateStr);
            if (item.spotStatusNumDtos == null) {
              d1.push(0);
              d2.push(0);
              d3.push(0);
              d4.push(0);
            } else {
              d1.push(item.spotStatusNumDtos[0].num);
              d2.push(item.spotStatusNumDtos[1].num);
              d3.push(item.spotStatusNumDtos[2].num);
              d4.push(item.spotStatusNumDtos[3].num);
            }
          });
          this.option3.legend.data = typeList;
          this.option3.xAxis[0].data = dateList;
          this.option3.series = [
            {
              name: "正常停放",
              type: "bar",
              data: d1,
              barWidth: "12px",
              itemStyle: {
                normal: {
                  color: "#00FFF7",
                  barBorderRadius: [30, 30, 0, 0],
                },
              },
            },
            {
              name: "车辆乱停车位",
              type: "bar",
              data: d2,
              barWidth: "12px",
              itemStyle: {
                normal: {
                  color: "#FFF716",
                  barBorderRadius: [30, 30, 0, 0],
                },
              },
            },
            {
              name: "未正确停放",
              type: "bar",
              data: d3,
              barWidth: "12px",
              itemStyle: {
                normal: {
                  color: "#9602EB",
                  barBorderRadius: [30, 30, 0, 0],
                },
              },
            },
            {
              name: "无车停放",
              type: "bar",
              data: d4,

              barWidth: "12px",
              itemStyle: {
                normal: {
                  color: "#0FDB7B",
                  barBorderRadius: [30, 30, 0, 0],
                },
              },
            },
          ];
          // echarts3.clear();

          echarts3.setOption(this.option3);
        }
        // this.getSpotStatusCountHistogramFourInfo = res.data;
      });
    },
    //机器人当前速度
    getSpeed() {
      get("/back/robot/getSpeed", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.message == null) {
          return;
        }
        this.robotSpeed = res.message;
      });
    },
    //机器人运行模式
    getMode() {
      get("/back/robot/getMode", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.message == null) {
          return;
        }
        if (this.count > 300 || this.count == 300) {
          this.count = 0;
          if (countInter != null) {
            clearInterval(countInter);
          }
        }

        //播放报警mp3
        if (res.message === "人工介入" && this.count < 300) {
          that.$refs.audio.currentTime = 0; //从头开始播放
          that.$refs.audio.play(); //播放
          if (countInter != null) {
            return;
          }
          countInter = setInterval(() => {
            that.count = that.count + 1;
          }, 1000);
          // this.$refs.audio.pause(); //停止
        }
        this.robotMode = res.message;
      });
    },
    //告警信息
    getBizSpotRecordWarnByState() {
      get("/back/robot/getBizSpotRecordWarnByState", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.data == null) {
          return;
        }
        let list = [];
        let list1 = res.data;
        let a = [];
        list1.forEach((item, index) => {
          a.push(index + "");
          a.push(item.dictionaryName);
          // a.push("");
          a.push(item.addTime);
          a.push("未处理");
          list.push(a);

          a = [];
        });
        let da = JSON.parse(JSON.stringify(this.config2));

        da.data = list;
        this.config2 = da;

        this.alertTip = res.data;
      });
    },
    //四、异常告警（10秒刷一次）
    getRecordWarn() {
      // that.alreadySolve = 0;
      // that.noSolve = 0;
      // echarts4.clear();
      // echarts4.setOption(this.option4, true);

      get("/back/robot/getRecordWarn", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.data == null) {
          return;
        }
        that.alreadySolve = parseInt(res.data[0].value);
        that.noSolve = parseInt(res.data[1].value);
        that.allTip = res.data[0].value + res.data[1].value;
        this.option4.series[0].data[0].value = res.data[0].value;
        this.option4.series[0].data[1].value = res.data[1].value;
        // echarts4.clear();

        echarts4.setOption(this.option4, true);
      });
    },
    //五、任务列表（5秒刷新一次）
    getRobotTasks() {
      get("/back/robot/getRobotTasks", {
        robotId: that.robotId,
      }).then((res) => {
        if (!res.state) {
          return;
        }
        if (res.data == null) {
          return;
        }
        let list = [];
        let list1 = res.data;
        let a = [];
        list1.forEach((item, index) => {
          a.push(index + 1 + "");
          a.push(item.taskName);
          a.push(item.taskTime.substr(5));
          if (item.taskStatus == 1) {
            a.push("进行中");
          } else if (item.taskStatus == 2) {
            a.push("队列中");
          } else if (item.taskStatus == 3) {
            a.push("已结束");
          } else {
            a.push("挂起");
          }

          list.push(a);
          a = [];
        });
        let da = JSON.parse(JSON.stringify(this.config));
        this.config = da;
        da.data = list;
      });
    },
    //减法
    Subtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    // 处理总订单数字1
    toOrderNum(num) {
      num = num.toString();
      if (num.length < 2) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum(num); // 递归添加"0"补位
      } else if (num.length === 2) {
        // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
        this.orderNum = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform();
    },
    // 设置文字滚动
    setNumberTransform() {
      const numberItems = this.$refs.numberItem; // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum.filter((item) => !isNaN(item));
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`;
      }
    },
    // 处理总订单数字
    toOrderNum(num) {
      num = num.toString();
      // 把订单数变成字符串
      if (num.length < 4) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum(num); // 递归添加"0"补位
      } else if (num.length === 4) {
        // 订单数中加入逗号
        this.orderNum = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform();
    },
    // 处理总订单数字2
    toOrderNum2(num) {
      num = num.toString();
      if (num.length < 2) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum2(num); // 递归添加"0"补位
      } else if (num.length === 2) {
        // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
        this.orderNum1 = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform2();
    },
    // 设置文字滚动
    setNumberTransform2() {
      const numberItems = this.$refs.numberItem1; // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum1.filter((item) => !isNaN(item));
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`;
      }
    },
    // 处理总订单数字
    toOrderNum2(num) {
      num = num.toString();
      // 把订单数变成字符串
      if (num.length < 2) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum2(num); // 递归添加"0"补位
      } else if (num.length === 2) {
        // 订单数中加入逗号
        this.orderNum1 = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform2();
    },
    // 处理总订单数字3
    toOrderNum3(num) {
      num = num.toString();
      if (num.length < 2) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum3(num); // 递归添加"0"补位
      } else if (num.length === 2) {
        // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
        this.orderNum3 = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform3();
    },
    // 设置文字滚动
    setNumberTransform3() {
      const numberItems = this.$refs.numberItem3; // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum3.filter((item) => !isNaN(item));
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`;
      }
    },
    // 处理总订单数字
    toOrderNum3(num) {
      num = num.toString();
      // 把订单数变成字符串
      if (num.length < 2) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum3(num); // 递归添加"0"补位
      } else if (num.length === 2) {
        // 订单数中加入逗号
        this.orderNum3 = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform3();
    },
    // 处理总订单数字4
    toOrderNum4(num) {
      num = num.toString();
      if (num.length < 2) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum4(num); // 递归添加"0"补位
      } else if (num.length === 2) {
        // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
        this.orderNum4 = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform4();
    },
    // 设置文字滚动
    setNumberTransform4() {
      const numberItems = this.$refs.numberItem4; // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum4.filter((item) => !isNaN(item));
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`;
      }
    },
    // 处理总订单数字
    toOrderNum4(num) {
      num = num.toString();
      // 把订单数变成字符串
      if (num.length < 2) {
        num = "0" + num; // 如未满八位数，添加"0"补位
        this.toOrderNum4(num); // 递归添加"0"补位
      } else if (num.length === 2) {
        // 订单数中加入逗号
        this.orderNum4 = num.split(""); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
      }
      this.setNumberTransform4();
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      this.y1 = year + "   年   " + mon + "   月   " + da + "   日";
      this.y2 = h + "：" + m + "：" + s;
    },
    drawLine() {
      // 绘制图表
      // echarts1.setOption(this.option1);
      // echarts2.setOption(this.option2);
      // echarts3.setOption(this.option3);
      // echarts4.setOption(this.option4);
    },
    /**
     * row	所在行数据	Array<String>	---	---
        ceil	单元格数据	Array<Array>	---	[]
        rowIndex	行索引	Number	---	---
        columnIndex	列索引	Number	---	---
        #mouseover事件
 */
    openDia(row, ceil, rowIndex, columnIndex) {
      this.alertIndex = row.rowIndex;
      // this.showDia = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.topbtn66 {
  position: absolute;
  right: 30px;
  width: 80px;
  height: 100px;
  top: 50px;
  .f11 {
    height: 40px;
    width: 40px;
    display: none;
  }
}
.topbtn66:hover {
  .f11 {
    display: block;
  }
}

.box-item {
  position: relative;
  height: 45px;
  font-size: 50px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  //   line-height: 29px;
  //   font-size: 54px;
  line-height: 15px;
  text-align: center;
  list-style: none;
  writing-mode: vertical-lr;
  text-orientation: upright;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;

  /* overflow: hidden; */
}

[v-cloak] {
  display: none !important; /*屏幕闪烁*/
}
/* 默认逗号设置 */
.mark-item {
  width: 10px;
  height: 29px;
  margin-right: 5px;
  line-height: 10px;
  font-size: 40px;
  position: relative;
  & > span {
    position: absolute;
    width: 100%;
    bottom: 0;
    writing-mode: vertical-rl;
    text-orientation: upright;
  }
}
/*滚动数字设置*/
.number-item {
  width: 30px;
  height: 45px;
  background: #163069;
  /* 背景图片 */
  //   background: url(/images/text-bg-blue.png) no-repeat center center;
  //   background-size: 100% 100%;
  // background: #ccc;
  list-style: none;
  margin-right: 5px;

  & > span {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    width: 100%;
    height: 100%;
    writing-mode: vertical-rl;
    text-orientation: upright;
    overflow: hidden;
    & > i {
      font-style: normal;
      position: absolute;
      top: -9px;
      left: 50%;
      transform: translate(-50%, 0);
      transition: transform 1s ease-in-out;
      letter-spacing: 10px;
    }
  }
}
.number-item:last-child {
  margin-right: 0;
}
.robotDot {
  background: red;
  animation: flash 0.4s linear infinite;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  position: absolute;
  left: 40%;
  top: 40%;
}

@keyframes flash {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.bottomContent3Diatxt4 {
  margin-left: 28px;
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  display: flex;
  align-items: center;
  color: #90a9c8;
  margin-top: 8px;
}
.bottomContent3Diatxt2 {
  margin-top: 10px;
  // margin-bottom: 17px;
  margin-left: 28px;
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  display: flex;
  align-items: center;
  color: #90a9c8;
}
.bottomContent3Diatxt3 {
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  margin-left: 12px;
  width: 70%;
  line-height: 20px;
}
.bottomContent3Diaimg {
  width: 18px;
  height: 18px;
}
.bottomContent3Diatxt {
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
  margin-top: 19px;
  width: 100%;
  padding: 0 23px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 89%;
}
.bottomContent3Dia {
  background-image: url("http://bz.njrentong.com/dialog@.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  right: 56px;
  bottom: 31px;
  z-index: 1001;
  width: 416px;
  height: 231px;
}
.tanchuang {
  width: 416px;
  height: 231px;
}
.topContentimg {
  margin-top: 16px;
  // width: 97%;
  width: 642px;
  height: 238.5px;
  margin-left: 0.5%;
  // height: 260px;
}
.cans {
  position: absolute;
  left: 0.5%;
  top: 16px;
}
.bottomContent3img1 {
  width: 45%;
  height: 169px;
  margin-left: 3%;
  margin-top: 20px;
  margin-bottom: 9px;

  float: left;
}
.bottomContent3txt11 {
}
.bottomContent3txt1 {
  // display: flex;
  // margin-top: 21px;
  // padding: 0 17px;
  // justify-content: space-between;
  // flex-wrap: wrap;
}
.view4 {
  width: 300px;
  height: 170px;
  margin-left: 5%;
  margin-top: 20px;
  margin-bottom: 5px;
  border: 1px solid white;
  float: left;
  object-fit: fill;
}
.charts4 {
  height: 250px;
  width: 100%;
  margin-top: 40px;
}
.bottomContent2txt5 {
}
.bottomContent2txt7 {
  display: flex;
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #03e4e5;
  align-items: baseline;
}
.bottomContent2txt8 {
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #90a9c8;
  margin-left: 9px;
}
.bottomContent2txt6 {
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
}
.bottomContent2txt3 {
  margin-top: 35px;
  display: flex;
  align-items: center;
  padding: 0 31px;
  justify-content: space-between;
}
.bottomContent2txt4 {
  display: flex;
  align-items: center;
}
.ok {
  width: 31px;
  height: 31px;
  margin-right: 13px;
}
.bottomContent2txt2 {
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  width: 100%;
  margin-top: 7px;
  text-align: center;
  height: 20px;
  line-height: 20px;
}
.bottomContent2txt1 {
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #90a9c8;
  // margin-left: 9px;
}
.bottomContent2txt {
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-size: 40px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  padding-top: 35px;
}
.charts1 {
  width: 50%;
  height: 100%;
}
.bottomContent1_txt3 {
  display: flex;
  margin-top: 2px;
  margin-left: 24px;
  height: 220px;
}
.bottomContent1_txt2 {
  margin-top: 23px;
  margin-left: 24px;
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
}
.bottomContent1Img {
  width: 382px;
  height: 184px;
}
.bottomContent1_txt {
  margin-top: 31px;
  margin-left: 25px;
  display: flex;
}
.bottomContent3 {
  width: 37%;
  height: 527px;
  position: relative;
}
.bottomContent2 {
  width: 20%;
  height: 527px;
  position: relative;
  margin-left: 0.6%;
  margin-right: 9px;
}
.bottomContent1 {
  margin-left: 1.2%;
  width: 40%;
  height: 527px;
  position: relative;
}
.bottomContent {
  width: 100%;
  height: 527px;
  display: flex;
}
.centerlabel {
  display: flex;
  align-items: center;
}
.centerContenttxt10 {
  background-image: url("http://bz.njrentong.com/zhongjain_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  //   background-attachment: fixed;
  background-size: cover;
  width: 198px;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  // margin-left: 90px;
}
.centerContenttxt8 {
  font-size: 25px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  margin-left: 5px;
}
.centerContenttxt7 {
  font-size: 50px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  margin-left: 21px;
}
.centerContenttxt9 {
  font-size: 50px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  margin-left: 10px;
}
.centerContenttxt6 {
  background-image: url("http://bz.njrentong.com/zhongjain_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  //   background-attachment: fixed;
  background-size: cover;
  width: 160px;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  // margin-left: 60px;
}
.centerContenttxt4 {
  background-image: url("http://bz.njrentong.com/zhongjain_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  //   background-attachment: fixed;
  background-size: cover;
  width: 160px;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  // margin-left: 60px;
}
.centerContenttxt5 {
  font-size: 50px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  margin-left: 8px;
}
.centerContenttxt3 {
  font-size: 25px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 400;
  color: #90a9c8;
  margin-left: 12px;
}
.centerContenttxt2 {
  font-size: 50px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  margin-left: 23px;
}
.centerContenttxt1 {
  background-image: url("http://bz.njrentong.com/zhongjain_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  //   background-attachment: fixed;
  background-size: cover;
  width: 160px;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  // margin-left: 51px;
}
.centerContent {
  //   margin-top: 30px;
  margin-bottom: 21px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.bottomContent1_txttable {
  height: 184px;
  width: 315px;
  margin-left: 36px;
  ::v-deep .header-item {
    font-size: 20px !important;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold !important;
    color: #e8b372;
  }
  ::v-deep .row-item {
    color: #6b7cab;
    // color: #90a9c8;
    font-size: 17px !important;
    font-family: SourceHanSansSC-Regular !important;
    font-weight: bold !important;
    // margin-bottom: 8px !important;
  }
}
.bottomContent3txt2tablev3 {
  height: 100px;
  margin-top: 390px;
  position: absolute;
  z-index: 1000;
  ::v-deep .header-item {
    font-size: 20px !important;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold !important;
    color: #e8b372;
  }
  ::v-deep .row-item {
    color: #6b7cab;
    // color: #90a9c8;
    font-size: 20px !important;
    font-family: SourceHanSansSC-Regular !important;
    font-weight: bold !important;

    // margin-bottom: 12px !important;
  }
}
.left2center_col3table {
  //   width: 400px;
  height: 200px;

  margin-top: 20px;
  margin-left: 180px;
  ::v-deep .header-item {
    font-size: 20px !important;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold !important;
    color: #e8b372;
  }
  ::v-deep .row-item {
    color: #6b7cab;
    // color: #90a9c8;
    font-size: 20px !important;
    font-family: SourceHanSansSC-Regular !important;
    font-weight: bold !important;
    // margin-bottom: 12px !important;
  }
}
.left2Content {
  display: flex;
  position: relative;
  background: transparent;
}
.robot {
  height: 324px;
  width: 576px;
  position: absolute;
  left: -175px;
  top: -50px;
  -webkit-backface-visibility: hidden;
  background: transparent;
  // z-index: -1;
}
.topContent_txt7 {
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #fff715;
  margin-left: 25px;
}
.topContent_txt6 {
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #90a9c8;
  margin-left: 14px;
}
.topContent_txt5 {
  width: 6px;
  height: 6px;
  background: #00fff6;
  border-radius: 50%;
}
.topContent_txt4 {
  width: 14px;
  height: 14px;
  border: 1px solid #00fff6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0px 10px #00fff6, 0 0px 3.5px #00fff6 inset;
}
.topContent_txt3 {
  margin-top: 25px;
  display: flex;
  align-items: center;
}
.topContent_txt8 {
  margin-top: 9px;
  display: flex;
  align-items: center;
}
.topContent_txt2 {
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  margin-left: -14px;
}
.topContent_txt1 {
  margin-left: 47px;
}
.topContent_txt {
  display: flex;
}
.topImage {
  width: 1049px;
  height: 98px;
  z-index: 222;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.topButton {
  height: 97px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.topbtn1 {
  width: 289px;
  display: flex;
  justify-content: space-between;
  margin-top: 51px;
  margin-left: 7.5%;
}
.topbtn3 {
  width: 289px;
  display: flex;
  justify-content: space-between;
  margin-top: 51px;
  margin-right: 7.5%;
}
.icon_bgn {
  width: 128px;
  height: 46px;
}
.topbtn2 {
  background-image: url("http://bz.njrentong.com/icon_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  //   background-attachment: fixed;
  background-size: cover;
  width: 128px;
  height: 46px;
  font-size: 22px;
  font-family: SourceHanSansSC-Bold;
  font-weight: normal;
  color: #57f6ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.topContent {
  height: 293px;
  width: 100%;
  padding: 30px 22px 12px 25px;
  display: flex;
}
.left3 {
  width: 554px;
  height: 279px;
  position: relative;
}

.left2 {
  width: 654px;
  height: 279px;
  position: relative;
  margin-left: 12px;
}
.left1 {
  width: 650px;
  height: 279px;
  position: relative;
  margin-left: 9px;
}

.left1_icon1 {
  width: 3px;
  height: 17px;
  background: #31cdfc;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}
.left1_icon2 {
  width: 3px;
  height: 17px;
  background: #31cdfc;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100;
}
.left1bgn {
  background: linear-gradient(0deg, #087bc5, #0794ee, #0794ee, #5596fe);
  opacity: 0.13;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99;
}
.left1_txt {
  height: 25px;
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-top: 11px;
}
.left1_img1 {
  width: 24px;
  height: 15px;
  margin-right: 8px;
}
.chartsv3 {
  width: 168px;
  height: 168px;
  margin-top: 50px;
  margin-left: 50px;
}
</style>
